import { Text, TruncatedText } from '@/se/components/typography';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import withSize from '../../hocs/withSize';

const SizeAwareText = withSize(({ text, horizontalOverflow, onOverflow, indicator }) => {
  useEffect(() => {
    if (indicator !== horizontalOverflow) {
      onOverflow(horizontalOverflow);
    }
  }, [horizontalOverflow, indicator, onOverflow]);

  return <TruncatedText>{text}</TruncatedText>;
});

export default ({ text, onClick }) => {
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      width="100%"
      onClick={e => {
        e.stopPropagation();
        setExpanded(!expanded);
        if (onClick) {
          onClick(e);
        }
      }}
    >
      {expanded ? (
        <Text style={{ whiteSpace: 'pre-line' }}>{text}</Text>
      ) : (
        <SizeAwareText text={text} onOverflow={setOverflow} indicator={overflow} />
      )}
      {overflow && (
        <IconButton size="small" expanded={expanded} onClick={() => setExpanded(!expanded)}>
          <ExpandMoreIcon />
        </IconButton>
      )}
    </Box>
  );
};
